import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Loading from '@components/loading'
import FormTitle from '@components/text/formTitle'
import PrimaryButton from '@components/inputs/button/primaryButton'
import FormInput from '@components/inputs/formInput'
import PasswordStrengthChecker from '@components/passwordStrengthChecker'
import PasswordMustHave from '@components/passwordStrengthChecker/passwordMustHave'
import RequiredFields from '@components/requiredFields'
import { WindowContext } from '@components/windowContextProvider'

import { invalidPasswords, validatePasswordsFields } from '@util/validationUtil'
import { changePassword as changePasswordAction } from '@actions/user'
import {
  Container,
  TitleContainer,
  FormSection,
  ButtonContainer,
  FormFields,
  Section,
  PasswordFields,
  SectionScroll
} from './styles'

const ChangePasswordModal = ({ changePassword, isOpen, setClose }) => {
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [errors, setErrors] = useState('')
  const [loading, setLoading] = useState(false)

  const { clientHeight } = React.useContext(WindowContext)
  const onChange = (e, setState) => {
    setState(e.target.value)
  }

  const onError = (data) => {
    setLoading(false)
    if (data.message) {
      const message = data.message.split(':')
      setErrors({
        ...errors,
        password: message[1]
      })
    } else {
      clearFields()
      setClose()
    }
  }

  const clearFields = () => {
    setPassword('')
    setNewPassword('')
    setPasswordConfirm('')
  }

  const handleClickSave = () => {
    setLoading(true)
    changePassword(
      {
        password,
        newPassword,
      },
      onError
    )
  }

  function checkOnUnfocus(label) {
    const error = label === 'passwordConfirm'
      ? validatePasswordsFields[label](newPassword, passwordConfirm)
      : validatePasswordsFields[label](password, newPassword)
    if (error) {
      setErrors({
        ...errors,
        [label]: error
      })
    } else {
      const aux = errors
      delete aux[label]
      setErrors({ ...aux })
    }
  }

  return (
    <Container isOpen={isOpen} clientHeight={clientHeight}>
      <SectionScroll>
        <TitleContainer>
          <FormTitle title="Alterar Senha" onClickGoBack={setClose} />
        </TitleContainer>
        <FormFields>
          <FormSection>
            <FormInput
              type="password"
              value={password}
              onChange={(e) => onChange(e, setPassword)}
              onBlur={() => checkOnUnfocus('password')}
              error={errors.password}
              label="Senha atual"
              required
            />
            <FormInput
              type="password"
              value={newPassword}
              onChange={(e) => onChange(e, setNewPassword)}
              onBlur={() => checkOnUnfocus('newPassword')}
              label="Nova senha"
              error={errors.newPassword}
              required
            />
            <FormInput
              type="password"
              value={passwordConfirm}
              onBlur={() => checkOnUnfocus('passwordConfirm')}
              onChange={(e) => onChange(e, setPasswordConfirm)}
              error={errors.passwordConfirm}
              label="Confirme a nova senha"
              required
            />
          </FormSection>

          <Section>
            <PasswordStrengthChecker password={newPassword} />
            <RequiredFields />
          </Section>
        </FormFields>

        <PasswordFields>
          <PasswordMustHave password={newPassword} />
        </PasswordFields>
      </SectionScroll>

      <ButtonContainer>
        <PrimaryButton
          onClick={handleClickSave}
          disabled={
            loading || invalidPasswords(password, newPassword, passwordConfirm)
          }
        >
          {loading ? <Loading /> : 'Salvar'}
        </PrimaryButton>
      </ButtonContainer>
    </Container>
  )
}

ChangePasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func,
  changePassword: PropTypes.func.isRequired,
}

ChangePasswordModal.defaultProps = {
  setClose: null,
  isOpen: false,
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    changePassword: changePasswordAction,
  },
  dispatch
)

export default connect(null, mapDispatchToProps)(ChangePasswordModal)
